export function modifySelector(selector, elementId) {
    // Split apart all the selector parts
    var selectorParts = selector.split(' ');
    if (!selector.startsWith(':root')){
        // prepend our targeted element ID
        selectorParts.unshift('#' + elementId);
    } else {
        // Remove the :root selector and replace with element ID
        selectorParts[0] = '#' + elementId;
    }

    // Remove any references to HTML or BODY elements which won't be present inside our target element
    selectorParts = selectorParts.filter((part) => !part.match(/^(html|body)$/i));

    // Combine it back into our new rule
    return selectorParts.join(" ");

}

function modifyCSSRules(cssRule, elementId) {
    if (cssRule instanceof CSSStyleRule) {
        // Split the rules selector into a list of selectors
        var selectors = cssRule.selectorText.split(',');
        // Modify each selector to be more specific
        var modifiedSelectors = selectors.map((selector) => modifySelector(selector, elementId));
        // Join the selectors back together
        var modifiedRule = modifiedSelectors.join(', ') + ' {' + cssRule.style.cssText + '}\r\n';
        return modifiedRule;

    } else if (cssRule instanceof CSSMediaRule) {
        var modifiedRules = [...cssRule.cssRules].map((rule) => modifyCSSRules(rule, elementId));
        return '@media ' + cssRule.media.mediaText + ' {' + modifiedRules.join(' ') + '}';
    } else if (cssRule instanceof CSSFontFaceRule) {
        return cssRule.cssText; // Shouldn't apply to anything that hasn't been styled with this font.
    }
}
let index = 0;
function loadStyleSheetApplyingToElement(elementId, styleSheetUrl, callback) {
    var style = document.createElement('link');
    style.setAttribute('rel', 'stylesheet');
    style.setAttribute('type', 'text/css');
    // Set a media type to prevent the stylesheet from applying globally
    style.setAttribute('media', '(max-width: 0)');
    style.setAttribute('href', styleSheetUrl);
    style.setAttribute("crossorigin", "anonymous");

    document.head.appendChild(style);
    function post_process() {
        var styleSheet = style.sheet;

        if (styleSheet.cssRules) {
            var rules = [...styleSheet.cssRules];
            var modifiedRules = rules.map((rule) => {
                return modifyCSSRules(rule, elementId);
            });

            var modifiedStyleSheet = modifiedRules.join(' ');
            style.remove();
            var style_el = document.createElement('style');
            style_el.innerHTML = modifiedStyleSheet;
            style_el.id = elementId + '-' + index + '-styles';
            index++;
            document.head.appendChild(style_el);
        }
        var targetEl = document.getElementById(elementId);
        targetEl.clientHeight; // Force a reflow, flushing the CSS changes
        if (callback) callback();
    }

    style.onload = post_process;
    style.onerror = function() {
        post_process();
        alert("Error loading editor stylesheet. The editor display may not be correct.");
        console.error("Error loading stylesheet '" + styleSheetUrl + "'.");
    }
}

export function loadStyleSheetsApplyingToElement(elementId, styleSheetUrls, callback) {
    // Loads a stylesheet and modifies the rules to only apply within the specified element.
    var element = document.getElementById(elementId);

    if (!element) {
        console.error("Element with ID '" + elementId + "' not found.");
        return;
    }

    function generate_callback(i, callback){
        return () =>{loadStyleSheetApplyingToElement(elementId, styleSheetUrls[i], callback)};
    }

    var next_callback = callback
    for (var i = styleSheetUrls.length -1; i  > 0; i--) {
        next_callback =generate_callback(i, next_callback);
    }
    loadStyleSheetApplyingToElement(elementId, styleSheetUrls[0], next_callback)

}
